<template>
<div class="report-line-chart">
  <div class="report-line-chart-wrapper">
    <div class="report-line-chart-inner">
      <e-chart ref="chart" />
    </div>
  </div>
  <div class="report-line-chart-title">{{title}}</div>
</div>
</template>

<script>
import EChart from '../Charts/ECharts'
import DataFormatter from './DataFormatter'
import ChartUtil from './ChartUtil'

export default {
  name: 'ReportLineChart',
  components: {EChart},
  props: {
    title: {
      type: String
    },
    param: {
      required: true,
      type: Object
    }
  },
  methods: {
    renderChart () {
      const {param} = this
      param.dimensions.forEach(dimension => {
        dimension.name = dimension.name || dimension.displayName
        dimension.seriesParam = {
          type: 'line',
          showSymbol: false
        }
      })

      const dataConfig = DataFormatter.formatter1(param)
      const chartOpt = ChartUtil.getOpt(dataConfig)
      this.$refs.chart.setOpt(chartOpt)
    }
  },
  watch: {
    param () {
      this.renderChart()
    }
  },
  mounted () {
    setTimeout(() => {
      this.renderChart()
    }, 0)
  }
}
</script>

<style lang="scss">
.report-line-chart {
  > .report-line-chart-title {
    font-size: 14px;
    margin-bottom: .5em;
    text-align: center;
  }

  > .report-line-chart-wrapper {
    position: relative;
    padding-bottom: 40%;

    > .report-line-chart-inner {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReportChart/ReportLineChart.vue